import script from "./ShortcutsKeyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutsKeyboard.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutsKeyboard.vue?vue&type=style&index=0&id=73cbcc9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73cbcc9a"]])

export default __exports__